// extracted by mini-css-extract-plugin
export default {"preform__title":"preform_preform__title__X0pZn"};